export const MATERIAL_VALUATION_ITEMS_PER_PAGE = 25;

export const VALUATION_TABS = {
  stocks: 'stocks',
  purchases: 'purchases',
  returns: 'returns',
};

export const VALUATION_TAB_LABELS = {
  stocks: 'Existencia',
  purchases: (count) => `Compras sin fuente${count ? ` (${count})` : ''}`,
  returns: (count) => `Retornos posibles${count ? ` (${count})` : ''}`,
};

/** Listado de `material_costs/preflight` que alimenta cada pestaña de fuentes. */
export const PREFLIGHT_SOURCE_BY_TAB = {
  [VALUATION_TABS.purchases]: 'purchases',
  [VALUATION_TABS.returns]: 'returns',
};

export const VALUATION_STATUS = {
  opened: 'opened',
  valued: 'valued',
  partial: 'partial',
  empty: 'empty',
  pending: 'pending',
};

export const VALUATION_STATUS_CONFIG = {
  [VALUATION_STATUS.opened]: { label: 'Aprobada', color: 'success' },
  [VALUATION_STATUS.valued]: { label: 'Valorizada', color: 'info' },
  [VALUATION_STATUS.partial]: { label: 'Parcial', color: 'warning' },
  [VALUATION_STATUS.empty]: { label: 'Sin existencia', color: 'default' },
  [VALUATION_STATUS.pending]: { label: 'Sin apertura', color: 'warning' },
};

/** Estados con físico sin cubrir por capas: admiten una apertura por la cantidad sin valorizar. */
export const REVIEWABLE_VALUATION_STATUSES = [VALUATION_STATUS.pending, VALUATION_STATUS.partial];

export const VALUATION_STATUS_OPTIONS = Object.entries(VALUATION_STATUS_CONFIG).map(
  ([value, config]) => ({ value, label: config.label })
);

export const INITIAL_STOCK_FILTERS = {
  search: '',
  uuid_warehouse: '',
  status: '',
};

export const VALUATION_TEXTS = {
  title: 'Stock y compras | Valoración de materiales',
  info:
    'Apertura estimada de la existencia que no tiene costo: valoriza solo la cantidad sin valorizar y entra como la más antigua en FIFO. Incluye lo reservado; no aumenta el stock ni modifica consumos históricos. Los precios incluyen IVA y excluyen fletes adicionales. Informe el respaldo del promedio.',
  legacyNote:
    'Compras y retornos anteriores al costeo: su recepción o reversa requiere una fuente aprobada; el documento original se conserva.',
  pendingQuantity: 'Cantidad pendiente',
  documentedPrice: 'Precio documentado ARS',
  quantity: 'Cantidad',
  emptyPurchases: 'No hay compras anteriores al costeo por revisar.',
  emptyReturns: 'No hay retornos posibles por revisar.',
  article: 'Artículo',
  warehouse: 'Depósito',
  physical: 'Físico',
  reserved: 'Reservado',
  valued: 'Valorizado',
  unvalued: 'Sin valorizar',
  status: 'Estado',
  actions: 'Acciones',
  searchMaterial: 'Material',
  clearFilters: 'Limpiar filtros',
  drawerTitle: 'Apertura de valoración',
  stockSection: 'Existencia a valorizar',
  openingSection: 'Apertura',
  previewTitle: 'Previsualización',
  previewQuantity: 'Cantidad a valorizar',
  previewTotal: 'Valor total',
  valuedAsOf: 'Valorizado al',
  totalSummary: 'Valor total de la apertura',
  amount: 'Promedio unitario en pesos',
  notes: 'Fuente y base del promedio',
  notesPlaceholder:
    'Explicá cómo obtuviste el precio promedio. Ej.: promedio de las últimas tres compras o estimación del área de Compras.',
  evidence: 'Referencias de documentos / aprobación',
  evidencePlaceholder:
    'Indicá qué respalda ese precio o quién lo validó. Ej.: facturas 123 y 456, presupuesto del proveedor o estimación validada por Compras.',
  preview: 'Previsualizar',
  review: 'Revisar apertura',
  confirm: 'Aprobar apertura',
  cancel: 'Cancelar',
  retry: 'Reintentar',
  error: 'No se pudo valorar la existencia',
  loadError: 'No se pudo cargar la existencia a valorizar.',
  empty: 'No hay existencia para revisar.',
  disabledValued: 'La existencia ya tiene valoración',
  disabledEmpty: 'No hay existencia física para valorizar',
  viewOpening: 'Ver apertura aprobada',
  detailTitle: 'Detalle de la apertura',
  detailStockSection: 'Existencia valorizada',
  detailValuesSection: 'Valores aprobados',
  detailSourceSection: 'Respaldo',
  detailApprovalSection: 'Aprobación',
  approvedQuantity: 'Cantidad aprobada',
  remainingQuantity: 'Queda en stock',
  unitCostArs: 'Costo unitario ARS (IVA incl.)',
  totalValueArs: 'Valor total ARS',
  unitCostUsd: 'Equivalente unitario USD',
  totalValueUsd: 'Equivalente total USD',
  quoteRate: 'Cotización ARS por USD',
  quoteAsOf: 'Cotización al',
  estimated: 'Tipo de costo',
  estimatedValue: 'Promedio estimado',
  documentedValue: 'Documentado',
  approvedBy: 'Aprobó',
  approvedAt: 'Fecha de aprobación',
  detailLoadError: 'No se pudo cargar la apertura.',
  close: 'Cerrar',
};
